const filterSearch = (inputValue, option) => option.value
  && option.value.toUpperCase().includes(inputValue.toUpperCase());

export default filterSearch;
